import { render, staticRenderFns } from "./HelpCenterHost.vue?vue&type=template&id=65e2144c&scoped=true"
import script from "./HelpCenterHost.vue?vue&type=script&lang=js"
export * from "./HelpCenterHost.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterHost.vue?vue&type=style&index=0&id=65e2144c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e2144c",
  null
  
)

export default component.exports